/** @jsx jsx */
/* eslint react/prop-types: 0 */
import { jsx, Styled } from "theme-ui"
import { graphql } from "gatsby"

import Layout, { Container, Row, Col } from "components/layout"
import Infographic, { InfographicLg } from "components/infographic"
import StarBurst from "components/star-burst"

import useLocale from "hooks/use-locales"

import BarGraph from "components/svgs/bar-graph"
import Checkmarks from "components/svgs/checkmarks"
import DotLine from "components/svgs/dot-line"
import Folder from "components/svgs/folder"
import PetriDish from "components/svgs/petri-dish"
import RandomDots from "components/svgs/random-dots"

const OurImpactPage = ({ data }) => {
  const { t, locale } = useLocale()

  return (
    <Layout pageTitle={t("impact.title")} description={t("impact.description")}>
      <Container>
        <StarBurst left>{t("impact.title")}</StarBurst>
        <Styled.h2>{t("impact.h.1")}</Styled.h2>
        <Row sx={{ flexWrap: "wrap" }}>
          <Col sx={{ width: ["90%", "50%"] }}>
            <InfographicLg Icon={BarGraph} value={t("impact.stat.one.value")}>
              {t("impact.stat.one.text")}
            </InfographicLg>
          </Col>
          <Col sx={{ width: ["90%", "50%"] }}>
            <InfographicLg Icon={Folder} value={t("impact.stat.two.value")}>
              {t("impact.stat.two.text")}
            </InfographicLg>
          </Col>
        </Row>
        <InfographicLg Icon={DotLine} value={t("impact.stat.three.value")}>
          {t("impact.stat.three.text")}
        </InfographicLg>
        <Row sx={{ flexWrap: "wrap" }}>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconOne.childImageSharp.fixed}
              value={t("impact.stat.five.value")}
            >
              {t("impact.stat.five.text")}
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconTwo.childImageSharp.fixed}
              value={t("impact.stat.seven.value")}
            >
              {t("impact.stat.seven.text")}
            </Infographic>
          </Col>
        </Row>
        <Row sx={{ flexWrap: "wrap" }}>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={
                locale === "en"
                  ? data.iconThree.childImageSharp.fixed
                  : data.iconThreeFr.childImageSharp.fixed
              }
              value={t("impact.stat.eight.value")}
            >
              {t("impact.stat.eight.text")}
            </Infographic>
          </Col>
        </Row>
        <Styled.h2>{t("impact.h.2")}</Styled.h2>
        <InfographicLg Icon={RandomDots} value={t("impact.stat.nine.value")}>
          <span
            dangerouslySetInnerHTML={{ __html: t("impact.stat.nine.text") }}
          />
        </InfographicLg>

        <Row sx={{ flexWrap: "wrap" }}>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={
                locale === "en"
                  ? data.iconFour.childImageSharp.fixed
                  : data.iconFourFr.childImageSharp.fixed
              }
              value={t("impact.stat.ten.value")}
            >
              {t("impact.stat.ten.text")}
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={
                locale === "en"
                  ? data.iconFive.childImageSharp.fixed
                  : data.iconFiveFr.childImageSharp.fixed
              }
              value={t("impact.stat.eleven.value")}
            >
              {t("impact.stat.eleven.text")}
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconSix.childImageSharp.fixed}
              value={t("impact.stat.twelve.value")}
            >
              {t("impact.stat.twelve.text")}
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconSeven.childImageSharp.fixed}
              value={t("impact.stat.thirteen.value")}
            >
              {t("impact.stat.thirteen.text")}
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconEight.childImageSharp.fixed}
              value={t("impact.stat.fourteen.value")}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: t("impact.stat.fourteen.text"),
                }}
              />
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconNine.childImageSharp.fixed}
              value={t("impact.stat.fifteen.value")}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: t("impact.stat.fifteen.text"),
                }}
              />
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconTen.childImageSharp.fixed}
              value={t("impact.stat.sixteen.value")}
            >
              {t("impact.stat.sixteen.text")}
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconEleven.childImageSharp.fixed}
              value={t("impact.stat.seventeen.value")}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: t("impact.stat.seventeen.text"),
                }}
              />
            </Infographic>
          </Col>
        </Row>
        <Styled.h2>{t("impact.h.3")}</Styled.h2>
        <InfographicLg
          Icon={Checkmarks}
          value={t("impact.stat.eighteen.value")}
        >
          {t("impact.stat.eighteen.text")}
        </InfographicLg>
        <InfographicLg Icon={PetriDish} value={t("impact.stat.nineteen.value")}>
          {t("impact.stat.nineteen.text")}
        </InfographicLg>
        <Row sx={{ flexWrap: "wrap" }}>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconTwelve.childImageSharp.fixed}
              value={t("impact.stat.twenty.value")}
            >
              {t("impact.stat.twenty.text")}
            </Infographic>
          </Col>
          <Col sx={{ width: ["100%", "100%", "50%"] }}>
            <Infographic
              fixed={data.iconThirteen.childImageSharp.fixed}
              value={t("impact.stat.twentyone.value")}
            >
              {t("impact.stat.twentyone.text")}
            </Infographic>
          </Col>
        </Row>
        <hr />
        <Styled.p>{t("impact.note")}</Styled.p>
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query ImpactPageQuery {
    iconOne: file(relativePath: { eq: "impact-icon-1.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconTwo: file(relativePath: { eq: "impact-icon-2.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconThree: file(relativePath: { eq: "impact-icon-3.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconThreeFr: file(relativePath: { eq: "impact-icon-3-fr.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconFour: file(relativePath: { eq: "impact-icon-4.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconFourFr: file(relativePath: { eq: "impact-icon-4-fr.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconFive: file(relativePath: { eq: "impact-icon-5.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconFiveFr: file(relativePath: { eq: "impact-icon-5-fr.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconSix: file(relativePath: { eq: "impact-icon-6.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconSeven: file(relativePath: { eq: "impact-icon-7.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconEight: file(relativePath: { eq: "impact-icon-8.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconNine: file(relativePath: { eq: "impact-icon-9.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconTen: file(relativePath: { eq: "impact-icon-10.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconEleven: file(relativePath: { eq: "impact-icon-11.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconTwelve: file(relativePath: { eq: "impact-icon-12.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    iconThirteen: file(relativePath: { eq: "impact-icon-13.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

export default OurImpactPage
